import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigService } from './app-config.service';
import { CrudService } from './crud.service';
import { VentaRapida } from 'app/Models/venta-rapida.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ReservacionesService extends CrudService<any> {

  constructor(private config: AppConfigService, http: HttpClient) {
    super(config.ReservacionesUrl, http);
  }

  crearVentaRapida(ventaRapida: VentaRapida):Observable<any>{
     let url = `${this.config.VentaRapidaUrl}/reservar`;

    return this.http.post(url, ventaRapida);

  }
}
